/* =============================================================================
 * BANNER DE CONSENTIMIENTO · la puerta, y la unica.
 * -----------------------------------------------------------------------------
 * LAS DOS OPCIONES PESAN LO MISMO. Aceptar y rechazar son el mismo boton con
 * distinto tono: mismo tamano, mismo sitio, un solo clic cada uno. No hay un
 * «aceptar» gigante con un «preferencias» escondido en gris, que es el patron
 * oscuro que la guia de cookies de la AEPD senala por su nombre. Si rechazar
 * cuesta mas que aceptar, el si no vale.
 *
 * NO SE PUEDE CERRAR SIN CONTESTAR, y no hay aspa. Un aspa es ambigua: ni es un
 * si ni es un no, y quien la pone acaba interpretandola como le conviene. Aqui
 * el silencio se queda en `unknown` y no enciende nada — lo unico que hace es
 * volver a preguntar en la siguiente visita.
 *
 * NO ES UN MODAL. No atrapa el foco ni bloquea la pagina: alguien que llega a
 * leer las fechas de la gira puede leerlas sin contestar nada. Un muro
 * obligatorio para ver contenido publico tampoco es consentimiento libre.
 * ========================================================================== */
import { useState } from 'react';
import { readConsent, writeConsent } from './consent';
import styles from './ConsentBanner.module.css';

export function ConsentBanner() {
  /* Inicializador PEREZOSO, no un efecto: `readConsent` toca `localStorage` y no
   * debe correr en cada repintado. Aqui se puede leer en el primer render sin
   * riesgo porque esta app no se pre-renderiza en el servidor —`dist/index.html`
   * sale con el `#root` vacio—, asi que no hay HTML previo con el que
   * descuadrarse. En una app con SSR esto SI tendria que ir en un efecto. */
  const [visible, setVisible] = useState(() => readConsent() === 'unknown');

  if (!visible) return null;

  const answer = (value: 'granted' | 'denied') => () => {
    writeConsent(value);
    setVisible(false);
  };

  return (
    <aside
      className={styles.banner}
      // `region` y no `dialog`: no captura el foco ni bloquea el resto.
      role="region"
      aria-labelledby="az-consent-title"
    >
      <div className={styles.inner}>
        <div className={styles.text}>
          <p id="az-consent-title" className={styles.title}>
            Cookies de medición
          </p>
          <p className={styles.body}>
            Usamos una cookie de Meta para saber qué destinos de la gira interesan más y no repetir anuncios a
            quien ya nos ha visto. <strong>No la activamos si no quieres</strong>, y la web funciona igual sin
            ella.
          </p>
        </div>
        <div className={styles.actions}>
          <button type="button" className={styles.reject} onClick={answer('denied')}>
            Solo lo necesario
          </button>
          <button type="button" className={styles.accept} onClick={answer('granted')}>
            Aceptar
          </button>
        </div>
      </div>
    </aside>
  );
}
